import React, { useEffect } from "react";
import Header from "../component/header";
import CourseSelection from "../component/courseSelection";
// import { useAuth } from '../util/AuthContext';

export default function CourseSelectionPage(){
    
    // const dateOfBirth = sessionStorage.getItem("dateOfBirth");
    // const mobileNo = parseInt(sessionStorage.getItem("mobileNo"));
    // const univID = parseInt(sessionStorage.getItem("univID"));
    // const dateOfBirth = "2018-01-01"
    // const mobileNo = "99999999"
    // const univID = 23

    // console.log(mobileNo, dateOfBirth, univID)

    // const { login } = useAuth();
    // useEffect(()=>{
    //     login(dateOfBirth,mobileNo,univID);
    // }, []);

    return(
        <>
            <Header/>
            <CourseSelection/>
        </>
    )
}